<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      Editar Requerimiento calidad tipo
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name Field -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="nombre"
              rules="required"
            >
              <b-form-group
                label="Nombre"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="requirementQualityType.nombre"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          {{ $t('Lists.saveChanges') }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  // BFormTextarea,

  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import actionsImprovement from '@/services/actionsImprovement.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,

  },
  setup() {
    /* SERVICES */
    const {
      fetchRequirementQualityType,
      updateRequirementQualityType,
    } = actionsImprovement()

    // Data
    const requirementQualityType = ref({})
    fetchRequirementQualityType(router.currentRoute.params, data => {
      requirementQualityType.value = data
    })
    /* Events */
    const onSubmit = () => {
      updateRequirementQualityType(requirementQualityType.value)
        .then(() => {
          router.push({ name: 'apps-requirement-quality-type-list' })
        })
    }
    /* Validations */
    const requirementQualityTypeData = ref(JSON.parse(JSON.stringify(requirementQualityType.value)))
    const resetclienteData = () => {
      requirementQualityTypeData.value = JSON.parse(JSON.stringify(requirementQualityType))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetclienteData)
    return {
      // Data
      requirementQualityType,
      /* Events */
      onSubmit,
      // Validations
      required,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style>

</style>
